// extracted by mini-css-extract-plugin
module.exports = {"table":"SalesReportTable_table__2Roxd"};